import { render, staticRenderFns } from "./turnTable.vue?vue&type=template&id=423cf33b&scoped=true&"
import script from "./turnTable.vue?vue&type=script&lang=js&"
export * from "./turnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423cf33b",
  null
  
)

export default component.exports